export default {
	common: {
		disabled: 'Disabled',
		enabled: 'Enabled',
		saving: 'Saving…',
		error: 'Error',
		time: {
			time: 'Time',
			past: 'Past',
			present: 'Present',
			future: 'Future',
		},
		severity: {
			debug: 'Debugging',
			info: 'Informational',
			warning: 'Warning',
			critical: 'Critical',
			emergency: 'Emergency',
		},
	},
	sidebar: {
		dashboard: 'Dashboard',
		bands: 'Bands',
		stages: 'Stages',
		timeslots: 'Timeslots',
		shifts: 'Shifts',
		screens: 'Screens',
		stage_manager_shifts: 'Stage Manager Shifts',
		stage_notifications: 'Notifications',
		admin_header: 'Administration',
		stage_plan_items: 'Risers & pictures',
	},
	pages: {
		dashboard: {
			title: 'Dashboard',
			add: 'Add new Task',
			current_tasks: 'Tasks Today',
			no_entries: 'No entries',
			no_stages: 'No stages found',
		},
		bands: {
			title: 'Bands',
			add: 'Add new Band',

			deleted: 'Band "{name}" deleted succesfully.',
			updated: 'Band "{name}" updated succesfully.',
			created: 'Band "{name}" created succesfully.',
		},
		timeslots: {
			title: 'Timeslots',
			add: 'Add new Entry',

			deleted: 'Timeslot "{name}" deleted succesfully.',
			updated: 'Timeslot "{name}" updated succesfully.',
			created: 'Timeslot "{name}" created succesfully.',
		},
		stages: {
			title: 'Stages',
			add: 'Add new Stage',

			deleted: 'Stage "{name}" deleted succesfully.',
			updated: 'Stage "{name}" updated succesfully.',
			created: 'Stage "{name}" created succesfully.',
			plan: 'Stage plan',
			edit: 'Edit stage',
		},
		stage_notifications: {
			title: 'Stage Notifications',
			add: 'Add new Stage Notification',

			deleted: 'Notification "{name}" deleted succesfully.',
			updated: 'Notification "{name}" updated succesfully.',
			created: 'Notification "{name}" created succesfully.',
		},
		shifts: {
			title: 'Shifts',
			add: 'Add new Shift',

			deleted: 'Shift "{name}" deleted succesfully.',
			updated: 'Shift "{name}" updated succesfully.',
			created: 'Shift "{name}" created succesfully.',
		},
		stage_manager_shifts: {
			title: 'Stage Manager Shifts',
			add: 'Add new Stage Manager Shift',

			deleted: 'Stage Manager Shift for "{name}" deleted succesfully.',
			updated: 'Stage Manager Shift for "{name}" updated succesfully.',
			created: 'Stage Manager Shift for "{name}" created succesfully.',
		},
		screens: {
			title: 'Screens',
			add: 'Add new Screen',

			deleted: 'Screen "{name}" deleted succesfully.',
			updated: 'Screen "{name}" updated succesfully.',
			created: 'Screen "{name}" created succesfully.',

			copy_screen_link: 'Copy Screen Link',
			copy_screen_link_success: 'Copied link to view screen "{name}" to your clipboard.',
			copy_screen_link_failure: 'Failed to copy screen link to your clipboard.',
		},
		settings: {
			logos: {
				title: 'Logos',
				logo1: 'Logo 1',
				logo2: 'Logo 2',
				saved: 'Logos saved successfully.',
			},
			idle_texts: {
				title: 'Screen Idle Texts',
				hint: 'Shown on the stage screen timer when no slot is live. A day starts at 06:00.',
				before_event: 'Before the event starts',
				before_first_slot: 'Before the first slot of the day',
				after_event: 'After the last slot of the event',
				saved: 'Idle texts saved successfully.',
			},
		},
		integrations: {
			producely: {
				title: 'Producely',
				path: 'API Path',
				token: 'API Token',
				save: 'Save settings',
				saved: 'Settings saved successfully.',
				import: 'Start import',
				importing: 'Importing…',
				result: 'Import result',
				created: 'Created',
				updated: 'Updated',
				bands: 'Bands',
				timeslots: 'Timeslots',
			},
		},
		stage_plan: {
			no_plan: 'This stage has no top view yet. Risers and pictures can be placed anyway.',
			upload_plan: 'Upload top view',
			back: 'Back to the stages',
			add_rect: 'Riser',
			add_image: 'Picture',
			edit_stage: 'Edit stage and top view',
			kind: {
				rect: 'Riser',
				image: 'Picture',
			},
			context: {
				edit: 'Edit',
				rotate: 'Rotate 90°',
				duplicate: 'Duplicate',
				delete: 'Delete',
				add_rect: 'Add riser here',
				add_image: 'Add picture here',
			},
			conflict_title: 'Not saved',
			conflict: '"{name}" was changed by someone else in the meantime. The plan now shows the current state.',
		},
		stage_plan_items: {
			title: 'Risers & pictures of the stage plans',
		},
		band: {
			not_found: 'This band does not exist in this event (any more).',
			no_stage: 'Not on a stage yet',
			confirm_delete:
				'Do you really want to delete the band "{name}" with its timeslots, documents and requirements? This cannot be undone.',
			unsaved_title: 'Unsaved changes',
			unsaved_text:
				'Some changes on this page are not saved yet. Do you want to discard them and leave the page?',
			general: {
				contacts: 'Contact persons',
				no_contacts: 'No contact persons yet.',
			},
			timeslots: {
				no_stage:
					"The band is not on a stage yet. Its timeslots show up in a stage's running order once you put it on a stage in the General tab.",
			},
			documents: {
				upload_as: 'File new documents under',
				hint: 'PDF, pictures, office documents, text or drawings (DWG, DXF), up to 30 MB per file',
				empty: 'No documents yet. Riders, stage instructions and technical drawings go here.',
				confirm_delete: 'Do you really want to delete the document "{name}"? This cannot be undone.',
			},
			requirements: {
				hint: 'What the band needs on stage. Sizes in meters.',
				empty: 'No requirements yet.',
			},
		},
	},
	modals: {
		edit_band: {
			create: 'Create new Band',
		},
		edit_timeslot: {
			edit: 'Edit existing Timeslot',
			create: 'Create new Timeslot',

			confirm_delete: 'Are you sure you want to delete the Timeslot "{name}"? This action cannot be undone!',
		},
		edit_stage: {
			edit: 'Edit existing Stage',
			create: 'Create new Stage',

			confirm_delete: 'Are you sure you want to delete the Stage "{name}"? This action cannot be undone!',
			plan_source: {
				pdf: 'Top view (PDF)',
				image: 'Top view (image)',
			},
			plan_remove: 'Remove top view',
			plan_hint: 'PDF with scale or image (PNG, JPEG, WebP). Of a PDF, the first page counts.',
			plan_scale_pdf: 'Scale',
			plan_scale_image: 'pixels per meter',
			plan_size: 'gives {width} × {height} m',
		},
		edit_stage_notification: {
			edit: 'Edit existing Notification',
			create: 'Create new Notification',

			confirm_delete: 'Are you sure you want to delete the Notification "{name}"? This action cannot be undone!',
		},
		edit_shift: {
			edit: 'Edit existing Shift',
			create: 'Create new Shift',

			confirm_delete: 'Are you sure you want to delete the Shift "{name}"? This action cannot be undone!',
		},
		edit_stage_manager_shift: {
			edit: 'Edit existing Stage Manager Shift',
			create: 'Create new Stage Manager Shift',

			confirm_delete:
				'Are you sure you want to delete the Stage Manager Shift for "{name}"? This action cannot be undone!',
		},
		edit_screen: {
			edit: 'Edit existing Screen',
			create: 'Create new Screen',

			confirm_delete: 'Are you sure you want to delete the Screen "{name}"? This action cannot be undone!',
		},
		edit_event: {
			create_demo_data: 'Fill with demo data',
			create_demo_data_hint:
				'Pre-fills the event with typical festival stages, bands, and crew shifts so you can explore the app right away.',
		},
		edit_timeslot_type: {
			create: 'Create new Timeslot Type',
			edit: 'Edit Timeslot Type',
		},
		import_event_data: {
			title: 'Import Data',
			file: 'File (CSV / TSV)',
			type: 'Type',
			type_artists: 'Artists',
			type_local_crew: 'Local Crew',
			type_stage_manager_shifts: 'Stage Manager Shifts',
			preview: 'Preview',
			confirm_import: 'Confirm Import',
			columns_artists:
				'Expected columns: Stage Name · Artist · Stagetime Start · Stagetime End · Load-In Start · Load-In End · Soundcheck Start · Soundcheck End',
			columns_local_crew:
				'Expected columns: Stage Name · Shift Name (e.g. early/late) · Crew Size · Shift Start · Shift End · Crew Type',
			columns_stage_manager_shifts:
				'Expected columns: Stage Name · Stage Manager Name · Contact Info · Shift Start · Shift End',
		},
		edit_stage_plan_item: {
			create_rect: 'Place riser',
			create_image: 'Place picture',
			edit_rect: 'Edit riser',
			edit_image: 'Edit picture',
			file_hint: 'SVG, PNG, JPEG or WebP, at most 4 MB. Its proportions are taken over.',
			keep_ratio: 'Keep proportions',
			confirm_delete: 'Remove "{name}" from the stage plan?',
		},
	},
	confirms: {
		delete_timeslot_type: {
			title: 'Delete Timeslot Type',
			text: 'Are you sure you want to delete the Timeslot Type "{item}"? This action cannot be undone!',
		},
	},
	buttons: {
		band: {
			open: 'Open band',
			back: 'Back to the bands',
			delete: 'Delete band',
			delete_image: 'Delete picture',
		},
		timeslot: {
			add: 'Add timeslot',
			remove: 'Remove timeslot',
		},
		band_contact: {
			add: 'Add contact person',
			remove: 'Remove contact person',
		},
		band_document: {
			rename: 'Rename',
			delete: 'Delete document',
		},
		band_requirement: {
			add_riser: 'Riser',
			remove: 'Remove requirement',
		},
	},

	data: {
		band: {
			name: 'Band',
			stage_name: 'Stagename',
			stage: 'Stage',
			description: 'Description',
			notes: 'Notes for the crew',
		},
		stage: {
			name: 'Stage',
			primary_color: 'Primary Color',
			secondary_color: 'Secondary Color',
			icon_uri: 'Logo',
			start_at: 'Opening Time',
			end_at: 'Closing Time',
			event_id: 'Event ID',
			row_color_indicator: '',
			plan: 'Top view',
			plan_scale: 'Scale',
		},
		stageNotification: {
			name: 'Stage Notification',
			title: 'Title',
			message: 'Message',
			icon_uri: 'Logo',
			icon: 'Icon',
			stage: 'Stage',
			severity: 'Severity',
			show_at: 'Show at',
			hide_at: 'Hide at',
			stage_name: 'Stage',
			severity_icon: '',
		},
		shift: {
			name: 'Shift',
			head_count: 'Head Count',
			start_at: 'Start Time',
			end_at: 'End Time',
			stage_name: 'Stage',
		},
		stageManagerShift: {
			name: 'Stage Manager Shift',
			user_avatar: '',
			user_name: 'Stage Manager',
			contact_info: 'Contact Info',
			start_at: 'Start Time',
			end_at: 'End Time',
			stage_name: 'Stage Name',
		},
		timeslot_type: {
			id: 'Id',
			name: 'Name',
			color: 'Color',
			preview: 'Preview',
			timeslots_count: '# Timeslots',
			description: 'Description',
		},
		timeslot: {
			name: 'Timeslot',
			comment: 'Comment',
			type: 'Type',
			start_at: 'Start Time',
			end_at: 'End Time',
			show_in_timer: 'Show in timer',
			stage_name: 'Stage',
		},
		screen: {
			name: 'Screen',
			last_heartbeat_at: 'Last Heartbeat At',
			last_ip: 'Last IP',
			enabled: 'Status',
			stage_name: 'Stage',
			event: {
				name: 'Event',
			},
			stage: {
				name: 'Stage',
			},
		},
		stage_plan_item: {
			name: 'Name',
			file: 'Picture',
			width: 'Width',
			height: 'Depth',
			rotation: 'Rotation',
			color: 'Colour',
			kind: '',
			stage_name: 'Stage',
			position: 'Position X / Y',
		},
		band_contact: {
			firstname: 'First name',
			lastname: 'Last name',
			email: 'Email',
			phone: 'Phone',
		},
		band_document: {
			category: 'Category',
		},
		band_requirement: {
			type: 'Type',
			quantity: 'Quantity',
			width: 'Width',
			depth: 'Depth',
			height: 'Height',
			note: 'Note',
		},
	},

	tabs: {
		context_settings: {
			general: 'General',
			timeslot_types: 'Timeslot Types',
			integrations: 'Integrations',
		},
		admin_settings: {
			design: 'Mail design',
		},
		band: {
			general: 'General',
			timeslots: 'Timeslots',
			documents: 'Documents',
			requirements: 'Requirements',
		},
	},

	filters: {
		timeslot_type: 'Timeslot Type',
	},
	components: {
		occupied_days: {
			note: 'Stages, timeslots or shifts already lie on the days from {first} to {last}. The dates have to include these days.',
		},
		svg_map: {
			zoom_in: 'Zoom in',
			zoom_out: 'Zoom out',
			fit: 'Show all',
			entities_smaller: 'Smaller labels',
			entities_bigger: 'Bigger labels',
			layers: 'Display',
			color: 'Colour',
			grayscale: 'Gray',
			coordinates: 'Coordinates',
			grid: 'Meter grid',
			center: 'Center here',
			copy_coordinates: 'Copy coordinates',
			cursor_outside: 'Move the pointer over the plan',
		},
		band_timeslots: {
			title: 'Timeslots',
			empty: 'No timeslots yet.',
			timeslot_type: 'Type',
			start: 'Start',
			end: 'End',
			show_in_timer: 'Show in timer',
		},
		band_image: {
			title: 'Picture or logo',
			none: 'No picture.',
			drop: 'Drop a picture here',
			replace: 'Drop another picture',
			hint: 'PNG, JPG, WebP or GIF up to 4 MB, stored at once',
			confirm_delete: "Do you really want to delete the band's picture?",
		},
	},
	enums: {
		band_document_category: {
			rider: 'Rider / stage instructions',
			technical_drawing: 'Technical drawings',
			other: 'Other',
		},
		band_requirement_type: {
			riser: 'Riser',
		},
	},
};
